import React from 'react';
import { ReactComponent as Github } from '../../assets/svg/Social/githubx.svg';
import { ReactComponent as Instagram } from '../../assets/svg/Social/instagram.svg';
import { ReactComponent as Twitter } from '../../assets/svg/Social/twitter.svg';
import { ReactComponent as Linkdedin } from '../../assets/svg/Social/linkedin.svg';

const socialLogoData = [
   {
      id: 1,
      label: 'GitHub',
      icon: <Github className="h-4 w-4 fill-current" />,
      link: 'https://github.com/',
      hover: 'hover:text-zinc-900 dark:hover:text-white',
   },
   {
      id: 2,
      label: 'Twitter',
      icon: <Twitter className="h-4 w-4 fill-current" />,
      link: 'https://twitter.com/',
      hover: 'hover:text-sky-500',
   },
   {
      id: 3,
      label: 'LinkedIn',
      icon: <Linkdedin className="h-4 w-4 fill-current" />,
      link: 'https://www.linkedin.com/in/',
      hover: 'hover:text-blue-500',
   },
   {
      id: 4,
      label: 'Instagram',
      icon: <Instagram className="h-4 w-4 fill-current" />,
      link: 'https://www.instagram.com/',
      hover: 'hover:text-rose-500',
   },
];

const SocialLogo = () => {
   return (
      <>
         {socialLogoData.map(({ id, icon, link, hover, label }) => (
            <a
               key={id}
               href={link}
               target="_blank"
               rel="noreferrer"
               aria-label={label}
               className={`flex h-9 w-9 items-center justify-center rounded-full border border-zinc-200/80 dark:border-zinc-800/80 bg-white/70 dark:bg-zinc-900/60 text-zinc-500 dark:text-zinc-400 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-soft ${hover}`}
            >
               {icon}
            </a>
         ))}
      </>
   );
};

export default SocialLogo;
